import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, MessageCircle, Save } from "lucide-react";
import { errText, fetchAgentAlerts, fetchNmCfg, ron, saveAgentPhone, saveNmCfg } from "@/lib/bf";
import { DemoTag } from "./BFStockTotal";

const Row = ({ a, onSaved }) => {
  const [ph, setPh] = useState(a.phone ? `+${a.phone}` : "");
  const save = () => saveAgentPhone(a.slug, ph).then(() => { toast.success(`Număr salvat pentru ${a.name}`); onSaved(); }).catch((e) => toast.error(errText(e, "Nu am putut salva")));
  return (
    <li data-testid={`bf-aa-${a.slug}`}>
      <div>
        <b>{a.name}</b>
        <span>{a.due === 1 ? "1 factură scadentă" : `${a.due} facturi scadente`} azi{a.due ? ` · ${ron(a.due_total)}` : ""} · {a.low === 1 ? "1 produs" : `${a.low} produse`} cu stoc mic</span>
      </div>
      <div className="interested-actions">
        <input className="bf-aa-phone" value={ph} onChange={(e) => setPh(e.target.value)} placeholder="07xx xxx xxx" data-testid={`bf-aa-phone-${a.slug}`} />
        <button type="button" className="st-btn st-btn--ghost" onClick={save} data-testid={`bf-aa-save-${a.slug}`}><Save size={14} /></button>
        {a.wa ? <a className="st-btn st-btn--light" href={a.wa} target="_blank" rel="noopener noreferrer" data-testid={`bf-aa-wa-${a.slug}`}><MessageCircle size={14} /> Trimite pe WhatsApp</a>
          : <span className="st-hint" data-testid={`bf-aa-none-${a.slug}`}>{a.message ? "Adaugă numărul" : "Nimic de trimis azi"}</span>}
      </div>
    </li>
  );
};

export default function BFAgentMessages() {
  const [rows, setRows] = useState(null);
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => fetchAgentAlerts().then(setRows).catch(() => setRows([])), []);
  useEffect(() => { load(); fetchNmCfg().then((c) => setCfg((x) => x || c)).catch(() => {}); }, [load]);
  const saveThr = () => { setBusy(true); saveNmCfg({ ...cfg, low_stock: Number(cfg.low_stock) || 0 }).then(() => { toast.success("Prag salvat"); load(); }).catch((e) => toast.error(errText(e, "Nu am putut salva"))).finally(() => setBusy(false)); };
  return (
    <section className="invite-box" data-testid="bf-agent-messages">
      <h3><MessageCircle size={18} /> Mesaje de dimineață pentru agenți <DemoTag /></h3>
      <p className="st-hint">Pentru fiecare agent: facturile saloanelor lui care ajung azi la scadență și produsele comandate de ele cu stoc mic. Un tap deschide WhatsApp cu mesajul gata scris către agent.</p>
      {cfg && (
        <div className="share-actions">
          <label className="bf-inv-field"><span>Stoc mic sub (buc.)</span><input value={cfg.low_stock} onChange={(e) => setCfg({ ...cfg, low_stock: e.target.value.replace(/\D/g, "") })} data-testid="bf-aa-threshold" /></label>
          <button type="button" className="st-btn st-btn--silver" onClick={saveThr} disabled={busy} data-testid="bf-aa-threshold-save">{busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Salvează pragul</button>
        </div>
      )}
      {!rows && <p className="st-hint">Se încarcă…</p>}
      {rows && !rows.length && <p className="st-hint" data-testid="bf-aa-empty">Nu există agenți cu link de recomandare.</p>}
      <ul className="bfa-leads">{(rows || []).map((a) => <Row key={a.slug} a={a} onSaved={load} />)}</ul>
    </section>
  );
}
